import { render, staticRenderFns } from "./ModalStartTrainingBlock.vue?vue&type=template&id=74248904"
import script from "./ModalStartTrainingBlock.vue?vue&type=script&lang=js"
export * from "./ModalStartTrainingBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports